import RuntimeError from './runtime-error';

export default class PermissionError extends RuntimeError {}
